import type { ThirdPartyIntegration } from './types';

export const createRadioOptions = (values: string[]) =>
  values.map((value) => ({
    id: value,
    value,
    name: value,
  }));

/**
 * Filter function for the All Organizations table.
 */
export const thirdPartyTableFilterFn = (row: ThirdPartyIntegration, filter: string) => {
  return (
    String(row.id).includes(filter.toLowerCase()) ||
    row.analyticsProvider.toLowerCase().includes(filter.toLowerCase()) ||
    row.apiToken.toLowerCase().includes(filter.toLowerCase())
  );
};
